import { Directive, HostListener, model, inject } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { TooltipDisplayDirective } from './tooltip-display.directive';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';

@Directive({
  selector: '[coreCopyToClipboard]',
  providers: [TooltipDisplayDirective, NgbTooltip],
  standalone: true,
})
export class CopyToClipboardDirective {
  private tooltipDisplay = inject(TooltipDisplayDirective);
  private translocoService = inject(TranslocoService);

  textToCopy = model<string>('', { alias: 'coreCopyToClipboard' });

  @HostListener('click')
  copyText() {
    if (this.textToCopy()) {
      this.showTooltip();
      navigator.clipboard.writeText(this.textToCopy()).then();
    }
  }

  private showTooltip() {
    this.tooltipDisplay.tooltipText.set(
      this.translocoService.translate('breadcrumbs.copied'),
    );
    this.tooltipDisplay.showTooltip();
  }
}
